import styled from "styled-components";

export const HierarchicalMultiSelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100% !important;
  height: 56px !important;
  padding: 20px 12px !important;
  background-color: #fff !important;
  border: thin solid #99a6b9 !important;
  border-radius: 8px !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #253858 !important;
  opacity: 1 !important;
  transition: border-color 0.3s ease-in-out !important;
  overflow: hidden;

  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.2s ease;
  }

  &.disabled {
    background-color: #e7e9ed !important;
    cursor: not-allowed;
    opacity: 0.7 !important;
  }

  &.has-error {
    border-color: #eb4553 !important; 
  }
`;

export const SelectedText = styled.span`
  color: #74849c;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgb(204, 204, 204);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px 0px;
  z-index: 1000;
  width: 100%;
  min-width: 250px;
  overflow: hidden;
  transition: background-color 0.2s ease;
  color: #395278;
  scrollbar-color: #ccc #fff;
  scrollbar-width: thin;
`;

export const SelectPanel = styled.div<{ $isNested: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SearchBar = styled.div`
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  border: none;
  background: #fafafa;
  color: #395278;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    background-color: #f5f5f5;
  }

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

export const PanelList = styled.div<{ $isNested: boolean }>`
  overflow-y: auto;
  max-height: 300px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 3px;
  }
`;

export const PanelItem = styled.div<{ $hasChildren: boolean }>`
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 16px 24px !important;
  color: #395278 !important;
  border-bottom: thin solid #e7e9ed !important;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100% !important;
  box-sizing: border-box;
  overflow: hidden;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ItemLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333333;
  user-select: none;
  overflow: hidden;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin: 0;
    cursor: pointer;
    accent-color: #3548c9;
    border: 2px solid #bdbdbd;
    border-radius: 2px;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
      border-color: #3548c9;
    }

    &:checked {
      background-color: #3548c9;
      border-color: #3548c9;
    }
  }
`;

export const CheckIcon = styled.div<{ checked: boolean }>`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.checked ? "#3548C9" : "transparent")};

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ItemArrow = styled.span`
  color: #757575;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-left: 8px;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const AllItem = styled(PanelItem)`
  background-color: #fafafa;
  ${ItemLabel} {
    font-weight: 500;
  }
`;

export const NoResults = styled.div`
  padding: 16px;
  text-align: center;
  color: #757575;
  font-size: 14px;
  background: #fafafa;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.2s ease;
  }
`;
